"use client"

import { useClickAway } from "ahooks"
import { FC, useRef } from "react"
import { createPortal } from "react-dom"
import FocusLock from "react-focus-lock"
import { CloseButton } from "src/components/common/CloseButton"
import { useBodyOverflowHidden } from "src/hooks/useBodyOverflowHidden"
import { useKeydown } from "src/hooks/useKeydown"
import { StorefrontDetailProduct } from "src/types/storefront"
import { OptionSelect } from "./OptionSelect"

export type MobileActionsModalProps = {
  product: StorefrontDetailProduct
  selections: Record<string, string>
  onValueClick: (optionId: string, valueName: string) => void
  optionsDisabled: boolean
  onClose: () => void
}

export const MobileActionsModal: FC<MobileActionsModalProps> = ({
  product,
  selections,
  onValueClick,
  optionsDisabled,
  onClose,
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useClickAway(onClose, ref)
  useKeydown("Escape", onClose)
  useBodyOverflowHidden(true)

  const portalContainer = document.querySelector("body")!
  const portalChildren = (
    <FocusLock autoFocus returnFocus className="fixed inset-0 bg-gray-900/50">
      <div ref={ref} className="fixed inset-x-0 bottom-0 bg-white">
        <div className="flex h-full min-h-full items-center justify-center text-center">
          <div className="flex size-full transform flex-col gap-3 overflow-hidden text-left">
            <div className="translate-x-2 -translate-y-2">
              <CloseButton onClick={onClose} />
            </div>

            <div className="flex flex-col gap-6 p-4">
              {product.options?.map((option) => {
                return (
                  <div key={option.id}>
                    <OptionSelect
                      option={option}
                      selectedValueName={selections[option.id]}
                      onValueClick={onValueClick}
                      disabled={optionsDisabled}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </FocusLock>
  )

  return <>{createPortal(portalChildren, portalContainer)}</>
}
